import { useRouteLoaderData } from "@hooks/useRouteLoaderData";
import { type ComponentProps, type FromSanityGraphQL } from "@ts/components";
import { type SanityKeyed, type SectionSizeGuide, type Size } from "@ts/sanity";
import React, { type FC } from "react";

type SizeGuideInputProps = ComponentProps & FromSanityGraphQL<SectionSizeGuide>;

type SizeGuideOutputProps = SizeGuideInputProps & {
  men?: SanityKeyed<Size>[];
  sizeTitles: string[];
  women?: SanityKeyed<Size>[];
};

export const withSizeGuide =
  (Component: FC<SizeGuideOutputProps>) =>
  ({ name = "SizeGuide", ...rest }: SizeGuideInputProps) => {
    const { sizeGuide } = useRouteLoaderData("routes/$site");
    const { men, women } = sizeGuide;
    const sizeTitles = ["us_au", "bared", "cm", "inch"];

    Component.displayName = name;
    return (
      <Component {...rest} men={men} sizeTitles={sizeTitles} women={women} />
    );
  };
